module.exports = __webpack_public_path__ + "media/images/favicons/apple-icon-60x60-3cb496c188b35d501757043c48867576.png";